import type { SVGProps } from 'react';
const SvgGoogle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    height={16}
    fill="none"
    width={16}
    {...props}
  >
    <path
      d="M11.882 9.106H8.4V7.2h6.034q.059.467.06.962c0 2.03-.7 3.725-1.896 4.892h-1.756V11.86a3.73 3.73 0 0 0 1.432-2.277l.094-.477z"
      stroke="currentColor"
      strokeWidth={0.8}
      fill="#4285F4"
    />
    <path
      d="M8 15.2c1.944 0 3.57-.648 4.758-1.746l-2.316-1.8c-.648.432-1.47.696-2.442.696-1.878 0-3.468-1.266-4.038-2.976H1.574v1.854A7.19 7.19 0 0 0 8 15.2"
      fill="#34A853"
    />
    <path
      d="M3.962 9.374A4.2 4.2 0 0 1 3.734 8c0-.48.084-.942.228-1.374V4.772H1.574a7.12 7.12 0 0 0 0 6.456z"
      fill="#FBBC05"
    />
    <path
      d="M8 3.65c1.062 0 2.01.366 2.76 1.08l2.052-2.052C11.57 1.514 9.944.8 8 .8a7.19 7.19 0 0 0-6.426 3.972l2.388 1.854C4.532 4.916 6.122 3.65 8 3.65"
      fill="#EA4335"
    />
  </svg>
);
export default SvgGoogle;
